import.meta.glob([
  '../images/**',
  '../fonts/**',
]);

// import external dependencies
import jQuery from 'jquery';
window.$ = window.jQuery = jQuery;

import 'bootstrap/dist/js/bootstrap.bundle.min';

import.meta.glob('./autoload/**/*.js', { eager: true });

// Import NPM packages
import 'slick-carousel';

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import templateFlex from './routes/flex';
import templateBuying from './routes/flex';
import templateBlog from './routes/blog';
import templateProductHighlight from './routes/archive';
import woocommerce from './routes/woo';
import archive from './routes/archive';
import singleProduct from './routes/product';
import category from './routes/blog';
import cart from './routes/cart';
import checkout from './routes/checkout';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Flex template
  templateFlex,
  // Buying template
  templateBuying,
  // Blog template
  templateBlog,
  // Product highlight template
  templateProductHighlight,
  // Woo Template
  woocommerce,
  // Archive Template
  archive,
  // Product single
  singleProduct,
  // Category
  category,
  // Cart
  cart,
  // Checkout
  checkout,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());